"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("../../../Button"));

var SubmitButton = function SubmitButton(props) {
  var label = props.label,
      disabled = props.disabled;

  var _useFormikContext = (0, _formik.useFormikContext)(),
      submitForm = _useFormikContext.submitForm;

  return /*#__PURE__*/_react["default"].createElement(StyledSubmitButton, {
    onClick: submitForm,
    disabled: disabled
  }, label);
};

var StyledSubmitButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "SubmitButton__StyledSubmitButton",
  componentId: "sc-qxbtau-0"
})([""]);
var _default = SubmitButton;
exports["default"] = _default;